import * as React from "react";
import Button from "@mui/joy/Button";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Box from "@mui/joy/Box";

interface AlertDialogModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title?: string;
  message: React.ReactNode;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: React.ReactNode;
}

const AlertDialogModal: React.FC<AlertDialogModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  icon = <WarningRoundedIcon />,
}) => {
  const handleClose = (
    event: React.MouseEvent,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick") {
      onClose();
    }
  };

  return (
    <React.Fragment>
      <Modal open={open} onClose={handleClose}>
        <ModalDialog
          variant="outlined"
          role="alertdialog"
        >
          <div>
            {title && (
              <DialogTitle>
                {icon}
                {title}
              </DialogTitle>
            )}
            <Box marginTop={2}>
              <DialogContent>
                {message}
              </DialogContent>
            </Box>
            <DialogActions>
              {confirmButtonText && (
                <Button variant="solid" color="primary" onClick={onConfirm}>
                  {confirmButtonText}
                </Button>
              )}
              {cancelButtonText && (
                <Button variant="plain" color="primary" onClick={onClose}>
                  {cancelButtonText}
                </Button>
              )}
            </DialogActions>
          </div>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
};

export default AlertDialogModal;
